import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { requestCanceller } from '../../service/axiosCancelToken';
import MainContext from '../context/mainContext';
import { checkShoppingCartItems } from '../../service/productService';
import './ShoppingCart.css';
import basketImg from './../container/image/shopping-basket.png'
import ShoppingCartItem from './ShopItem';
import Cookies from 'universal-cookie';
import priceFormat from './../../utils/showPriceFormat';
import { shoppingCartValidator } from '../../service/validatorForms';
import { createOrder } from '../../service/order2Service';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import LoadingSpinner from '../shared/LoadingSpinner';
let cookie = new Cookies();


const ShoppingCart = () => {

    const [shopItems, setShopItems] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const context = useContext(MainContext)
    const [fullName, setFullName] = useState('');
    const [address, setAddress] = useState('');
    const [telephone, setTelephone] = useState('');
    const [info, setInfo] = useState('');
    const [, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => setForceUpdate({}), []);
    const validatorRef = useRef(shoppingCartValidator());
    const history = useHistory();
    const { addToast } = useToasts();

    useEffect(() => {

        const cancelRequest = requestCanceller();

        const fetchShopItems = async () => {
            try {
                let cookieItems = cookie.get('shoppingCart') || [];
                if (!cookieItems.length) {
                    setShopItems([]);
                    return;
                }
                let ids = [];
                cookieItems.forEach(item => {
                    ids.push(item._id);
                });
                setIsLoading(true);
                const params = {
                    itemsIds: JSON.stringify(ids)
                }
                let { status, data } = await checkShoppingCartItems(params, { cancelToken: cancelRequest.signal });
                if (status === 201) {
                    let existedItems = data.items;
                    let newItems = [];
                    existedItems.forEach(item => {
                        cookieItems.forEach(element => {
                            if (item._id === element._id) {
                                newItems.push({ ...item, count: element.count });
                            }
                        })
                    });
                    setShopItems(newItems);
                    setIsLoading(false);
                }
            } catch (err) {

            }
        }
        fetchShopItems();
        return () => {
            cancelRequest.cancel();
        }

    }, [])
    const setShoppingCartHandler = (itemId, action, minValue) => {
        let items = cookie.get('shoppingCart') ? cookie.get('shoppingCart') : [];
        let findedIndex = items.findIndex(item => item._id === itemId);

        if (findedIndex > -1) {
            switch (action) {
                case 'INCREMENT':
                    items[findedIndex].count += 1;
                    context.setShoppingCart([...items])
                    cookie.set('shoppingCart', [...items])
                    break;
                case 'DECREMENT':
                    items[findedIndex].count -= 1;
                    if (items[findedIndex].count < minValue) {
                        items.splice(findedIndex, 1);
                    }
                    context.setShoppingCart([...items])
                    cookie.set('shoppingCart', [...items])
                    break;
                default:
                    break;
            }
        }
        else if (action === 'INCREMENT') {
            items.push({ _id: itemId, count: minValue });
            context.setShoppingCart([...items]);
            cookie.set('shoppingCart', [...items])
        }
    }
    const setShopItemsHandler = (itemId, action, minValue) => {
        let allShopItems = [...shopItems]
        let findedIndex = allShopItems.findIndex(item => item._id === itemId)
        switch (action) {
            case 'INCREMENT':
                allShopItems[findedIndex].count += 1;
                setShopItems([...allShopItems])
                break;
            case 'DECREMENT':
                allShopItems[findedIndex].count -= 1;
                if (allShopItems[findedIndex].count < minValue) {
                    allShopItems.splice(findedIndex, 1);
                    setShopItems([...allShopItems]);
                }
                break;
            default:
                break;
        }
    }
    const getTotalPrice = () => {
        let items = [...shopItems];
        let totalPrice = 0;
        items.forEach(product => {
            totalPrice += Number(product.ourPrice) * Number(product.count);
        });
        return totalPrice;
    }

    useEffect(() => {
        if (!context.loggedIn)
            return;
        setFullName(context.loggedIn.fullName || '');
        setAddress(context.loggedIn.address || '')
        setTelephone(context.loggedIn.telephone || '');
    }, [context.loggedIn])

    const submitOrderHandler = async () => {
        if (!context.loggedIn) {
            return context.showLogin()
        }

        try {
            if (validatorRef.current.allValid()) {

                let products = [];
                let allShopItems = [...shopItems];
                allShopItems.forEach(item => {
                    products.push({
                        productId: item._id,
                        title: item.title,
                        unit: item.unit,
                        count: item.count,
                        price: item.ourPrice * item.count
                    })
                })
                let facture = {
                    fullName: fullName,
                    telephone: telephone,
                    address: address,
                    info: info,
                    totalPrice: getTotalPrice().toString(),
                }
                const order = {
                    products: products,
                    facture: facture,
                    userId: context.loggedIn._id
                }
                setIsLoading(true);

                const { data, status } = await createOrder(order);

                if (status === 201) {
                    addToast("سفارش با موفقیت ثبت شد", {
                        appearance: 'success',
                        autoDismiss: true,
                    })

                    context.setShoppingCart([]);
                    cookie.set('shoppingCart', []);
                    setShopItems([]);
                    history.push('/order2-successfull', {
                        factureNumber: data.factureNumber,
                        price: order.facture.totalPrice,
                        fullName: order.facture.fullName,
                        mobileNumber: order.facture.telephone,
                        address: order.facture.address,
                        DateAndTime: data.dateAndTime,

                    })
                }
            }
            else {
                validatorRef.current.showMessages();
                forceUpdate();
            }
        } catch (err) {
            if (err.response && err.response.status === 401)
                addToast("شما مجوز دسترسی ندارید", {
                    appearance: 'error',
                    autoDismiss: true,
                })
            else if (err.response && err.response.status === 422)
                addToast("اطلاعات را به طور صحیح وارد کنید", {
                    appearance: 'error',
                    autoDismiss: true,
                })
            else if (err.response && err.response.status === 404)
                addToast("کاربر با این مشخصات وجود ندارد", {
                    appearance: 'error',
                    autoDismiss: true,
                })
            else if (err.response && err.response.status === 429)
                addToast("تعداد سفارشات تایید نشده شما به حداکثر تعداد مجاز رسیده اند", {
                    appearance: 'error',
                    autoDismiss: true,
                })
        }
    }

    return (
        <div className="shopping-cart bg-light container-sm">
            <div className="row  pb-5">
                <div className="col-12 col-sm-10 col-md-12 col-lg-8 mx-auto mt-sm-3 px-0 shadow bg-white">
                    <div className="cart-place">
                        <h1 className="d-flex justify-content-start align-items-center mb-3">
                            <span>
                                <img src={basketImg} alt="" style={{ width: '40px' }} />
                            </span>
                            <span>سبد خرید</span>
                        </h1>
                        <React.Fragment>
                            {
                                (shopItems && shopItems.length) &&
                                shopItems.map(item =>
                                    <ShoppingCartItem
                                        id={item._id}
                                        key={item._id}
                                        ourPrice={item.ourPrice}
                                        title={item.title}
                                        unit={item.unit}
                                        count={item.count}
                                        minValue={item.minValue}
                                        setShoppingCart={(itemId, action, minValue) => setShoppingCartHandler(itemId, action, minValue)}
                                        setShopItems={(itemId, action, minValue) => setShopItemsHandler(itemId, action, minValue)}
                                    />

                                )
                            }
                            {
                                (shopItems && !shopItems.length) &&
                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '152px' }}>
                                    <h5 className="font-weight-bold text-muted">
                                        سبد خرید شما خالی است
                                    </h5>
                                </div>
                            }
                            {
                                !shopItems &&
                                <div style={{ height: '150px' }} className="d-flex">
                                    <div className="text-center align-self-center mx-auto">
                                        <LoadingSpinner />
                                    </div>
                                </div>
                            }
                        </React.Fragment>
                    </div>
                </div>
                <div className="col-12 col-sm-10 col-md-12 col-lg-4 mx-auto mt-1 mt-sm-3 px-0 shadow" >
                    <div className="shop-facture">
                        <h1>پیش فاکتور</h1>
                        <div className="d-flex justify-content-between mt-3 text-success">
                            <span>مجموع خرید</span>
                            <span>
                                {shopItems && priceFormat(getTotalPrice())}
                                <span className="ml-1">تومان</span>
                            </span>
                        </div>
                        <div className="d-flex justify-content-between text-secondary my-2">
                            <span>نوع ارسال</span>
                            <span>پیک موتوری</span>
                        </div>
                        {
                            context.loggedIn &&
                            <form onSubmit={e => e.preventDefault()}
                            >
                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <label htmlFor="name23">
                                            نام گیرنده
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name23"
                                            placeholder=""
                                            value={fullName}
                                            onChange={e => setFullName(e.target.value)}
                                            onBlur={() => {
                                                if (fullName !== '') {
                                                    validatorRef.current.showMessageFor("fullName");
                                                    forceUpdate()
                                                }
                                            }}
                                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault() }}
                                        />
                                        {validatorRef.current.message(
                                            "fullName",
                                            fullName,
                                            "required|max:25"
                                        )}
                                    </div>
                                    <div className="form-group col-md-6"
                                        style={{ direction: "ltr" }}
                                    >
                                        <label htmlFor="phoneNumber1">تلفن گیرنده</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="phoneNumber1"
                                            placeholder=""
                                            value={telephone}
                                            onChange={e => setTelephone(e.target.value)}
                                            onBlur={() => {
                                                if (telephone !== '') {
                                                    validatorRef.current.showMessageFor("telephone");
                                                    forceUpdate();
                                                }
                                            }}
                                        />
                                        {validatorRef.current.message(
                                            "telephone",
                                            telephone,
                                            "required|phone"
                                        )}
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label htmlFor="exampleFormControlTextarea1">
                                        آدرس گیرنده
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="exampleFormControlTextarea1"
                                        value={address}
                                        rows="2"
                                        onChange={e => setAddress(e.target.value)}
                                        onBlur={() => {
                                            if (address !== '') {
                                                validatorRef.current.showMessageFor("address");
                                                forceUpdate();
                                            }
                                        }}
                                    ></textarea>
                                    {validatorRef.current.message(
                                        "address",
                                        address,
                                        "required"
                                    )}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="info-shop">
                                        توضیحات
                                    </label>
                                    <textarea
                                        className="form-control"
                                        id="info-shop"
                                        value={info}
                                        rows="2"
                                        onChange={e => setInfo(e.target.value)}
                                    ></textarea>
                                </div>
                            </form>
                        }
                        <div className="text-center">
                            <button className="btn btn-success catch-button mt-2"
                                disabled={isLoading || (context.shoppingCart && !context.shoppingCart.length)}
                                onClick={submitOrderHandler}
                            >
                                {
                                    isLoading ?
                                        <span>
                                            <span className="spinner-border spinner-border-sm mr-2 mb-1" ></span>
                                            <span className="">در حال ثبت سفارش ...</span>
                                        </span>
                                        :
                                        <span>
                                            {/* <i className="fa fa-check mr-"></i> */}
                                            <span className="">ثبت سفارش</span>
                                        </span>
                                }

                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ShoppingCart;